import { XIcon, ArrowLeftIcon } from "@heroicons/react/solid";
import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getSalaryList } from "../../../api/employeeDetails";
import Layout from "../../../components/layout/Layout";
import DatePicker from "react-datepicker";
import spinner from "../../../assets/images/spinner.gif";
// import Calendar from '../../components/Dates/Calendar'
import { downloadReport } from "../../../api";
// import { getAttendanceData } from '../../api/leaveApplicationForm'
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Pagination from "../../../components/pagination";
import Salary from "..";
import CompanyPayroll from "../CompanyPayroll";
import PrimaryLoader from "../../../components/common/PrimaryLoader";
import BreadCrumbs from "../../../components/ui/BreadCrumbs";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../../components/table/Table";
import RoundedContainer from "../../../components/containers/RoundedContainer";
import LinkButton from "../../../components/ui/LinkButton";
import { Button } from "../../../components/ui";

const getDateMonthString = (date) => {
  let tempDate = new Date(date);
  let month = tempDate.getMonth() + 1;
  return tempDate.getFullYear() + "-" + month;
};

function BaseSalary() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Salary", link: "/salary" },
  ];
  let initialData = {
    month_and_year: searchParams.get("month_and_year")
      ? new Date(searchParams.get("month_and_year"))
      : new Date(),
    prev_month_and_year: new Date(),
    page_number: searchParams.get("page_number") || 0,
    limit: searchParams.get("limit") || 20,
    search_query: searchParams.get("search_query") || "",
  };

  const [filterData, setFilterData] = useState(initialData);
  const [isFetching, setIsFetching] = useState(false);
  const [salaryList, setSalaryList] = useState([]);
  const [count, setCount] = useState("");
  const [companyPayout, setCompanyPayout] = useState([]);

  const handleDate = (value, name) => {
    let data = {
      ...filterData,
      [name]: value,
    };
    setFilterData(data);
    handleCalculateSalary(data);
    setSearchParams(data);
  };
  const handleCalculateSalary = (data) => {
    const temp = {
      ...data,
      month_year: filterData.month_and_year,
      page_number: filterData.page_number,
      search_query: filterData.search_query,
      limit: filterData.limit,
    };
    setIsFetching(true);
    getSalaryList(temp)
      .then((res) => {
        if (res.status === 200) {
          setSalaryList(res?.data.data);
          setCompanyPayout(res?.data?.company_payout);
          setCount(res?.data.total_count);
          setIsFetching(false);
          scrollToTop();
        }
      })
      .catch((err) => {
        alert("Something went wrong!");
        setIsFetching(false);
      });
  };

  const handleDownloadReport = () => {
    const temp = {
      ...filterData,
      month_year: getDateMonthString(filterData["month_and_year"]),
    };
    downloadReport(temp)
      .then((res) => {
        // console.log(res)
        // create file link in browser's memory
        const href = URL.createObjectURL(res.data);
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        const d = new Date();
        let fileName = `Salary_Report_${
          months[d.getMonth()]
        }_${d.getFullYear()}.xlsx`;
        // create "a" HTLM element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => {});
  };

  useEffect(() => {
    handleCalculateSalary(filterData);
  }, [filterData.page_number, filterData.search_query]);

  const handleNavigateToEmployeeDetail = (id, username) => {
    navigate(`/employee-salary-details/${id}/${username}?source=salary`);
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = {
      ...filterData,
      [name]: value,
    };
    setFilterData(data);
    setSearchParams(data);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  };
  const handlePageClick = (val) => {
    let data = {
      ...filterData,
      page_number: val.selected,
    };
    setFilterData(data);
    setSearchParams(data);
  };

  return (
    <Salary>
      <div className="px-4 my-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      <div className="mt-2">
        <div className="">
          <form className="flex items-end justify-between px-5">
            <div className="flex items-end space-x-4">
              <div>
                <input
                  type="text"
                  placeholder="Search By Name..."
                  name="search_query"
                  className="input"
                  onChange={handleSearch}
                />
              </div>
              <div className="min-w-[10rem]  basis-[35%]">
                <label className=" roboto label">Select Month/Year</label>
                <DatePicker
                  required
                  name="month_and_year"
                  autoComplete="false"
                  className="input"
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selected={filterData?.month_and_year}
                  onChange={(value) => handleDate(value, "month_and_year")}
                />
              </div>
            </div>
            <div className="px-4">
              <div className="flex space-x-4 items-end justify-between">
                {salaryList?.length > 0 && (
                  <div className="">
                    <Button type="button" onClick={handleDownloadReport}>
                      Download Report
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
        <CompanyPayroll
          data={companyPayout}
          filterData={filterData}
          type="employee"
          handleCalculateSalary={handleCalculateSalary}
        />

        {isFetching ? (
          <div className=" flex items-center justify-center mt-10">
            <PrimaryLoader />
          </div>
        ) : (
          <>
            {salaryList?.length > 0 && (
              <>
                <RoundedContainer className={"mx-4"}>
                  <div className="max-w-full overflow-x-auto">
                    <Table className="table-auto w-full">
                      <TableHead>
                        <TableHeaderCell className="w-1/6 min-w-[160px] text-base font-semibold">
                          Sr.No
                        </TableHeaderCell>
                        <TableHeaderCell className="w-3/6 min-w-[160px] text-base font-semibold">
                          Name
                        </TableHeaderCell>
                        {/* <TableHeaderCell className="w-1/6 min-w-[160px] text-base font-semibold">
                          User Type
                        </TableHeaderCell> */}
                        <TableHeaderCell className="w-2/6 min-w-[160px] text-base font-semibold">
                          Action
                        </TableHeaderCell>
                      </TableHead>
                      <TableBody>
                        {salaryList?.map((data, idx) => {
                          const {
                            employee_name,
                            status,
                            user_type,
                            company_employee_id,
                          } = data;
                          return (
                            <TableRow
                              key={idx}
                              className="cursor-pointer"
                              onClick={() =>
                                handleNavigateToEmployeeDetail(
                                  company_employee_id,
                                  employee_name
                                )
                              }
                            >
                              <TableCell className="text-dark font-medium text-sm">
                                {filterData.limit *
                                  (parseInt(filterData.page_number) + 1) -
                                  (filterData.limit - (idx + 1))}
                              </TableCell>
                              <TableCell className="text-dark font-medium text-sm">
                                {employee_name}
                              </TableCell>
                              {/* <TableCell className="text-dark font-medium text-sm capitalize">
                                {user_type}
                              </TableCell> */}
                              <TableCell className="text-dark font-medium text-sm">
                                {status === "left" ? (
                                  <div className="flex items-center justify-center">
                                    Left
                                  </div>
                                ) : (
                                  status === "joining_date_diff" && (
                                    <div className="flex items-center justify-center">
                                      Joining Date Diff
                                    </div>
                                  )
                                )}
                                {status === "not_generated" ? (
                                  <LinkButton
                                    onClick={(e) => e.stopPropagation()}
                                    to={
                                      "/salary/logs?company_employee_id=" +
                                      company_employee_id +
                                      "&date=" +
                                      filterData["month_and_year"] +
                                      "&prev_date=" +
                                      filterData["prev_month_and_year"] +
                                      "&status=not_generated" +
                                      "&emp=" +
                                      user_type
                                    }
                                  >
                                    Generate
                                  </LinkButton>
                                ) : (
                                  status === "generated" && (
                                    <>
                                      <Link
                                        onClick={(e) => e.stopPropagation()}
                                        to={
                                          "/salary/logs?company_employee_id=" +
                                          company_employee_id +
                                          "&date=" +
                                          filterData["month_and_year"] +
                                          "&prev_date=" +
                                          filterData["prev_month_and_year"] +
                                          "&status=generated" +
                                          "&emp=" +
                                          user_type
                                        }
                                        className="px-4 py-2 rounded bg-[color:var(--color1)] text-white"
                                      >
                                        View
                                      </Link>
                                    </>
                                  )
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </RoundedContainer>
                <RoundedContainer className={"mx-4"}>
                  <Pagination
                    currentPage={+filterData.page_number}
                    lengthofItems={count}
                    limit={filterData.limit}
                    onPageChange={handlePageClick}
                  />
                </RoundedContainer>
              </>
            )}
          </>
        )}
      </div>
    </Salary>
  );
}

export default BaseSalary;
